/**
 * Detects if an error is from an aborted/cancelled request
 * Handles various error wrapping patterns from $fetch
 *
 * @param {Error} error - The error to check
 * @returns {boolean} True if the error is from an aborted request
 */
export const isAbortError = (error) => {
  if (!error) return false;

  return (
    error.cause?.name === 'AbortError' ||
    error.name === 'AbortError' ||
    error.code === 'ABORT_ERR' ||
    error.code === 20 ||
    error.options?.signal?.aborted === true ||
    error.message?.toLowerCase().includes('abort') ||
    error.message?.toLowerCase().includes('cancel')
  );
};
